import { render, staticRenderFns } from "./LessonEditor.vue?vue&type=template&id=131d9027&scoped=true"
import script from "./LessonEditor.vue?vue&type=script&lang=js"
export * from "./LessonEditor.vue?vue&type=script&lang=js"
import style0 from "./LessonEditor.vue?vue&type=style&index=0&id=131d9027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d9027",
  null
  
)

export default component.exports